import React, { ChangeEvent, FC, useEffect } from 'react';
import PhoneInput2, { PhoneInputProps } from 'react-phone-input-2';
import { observer } from 'mobx-react';
import { countriesStore } from 'src/mobx/countriesStore';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps extends PhoneInputProps {
  onChange: (value: string, data: {}, event: ChangeEvent<HTMLInputElement>, formattedValue: string) => void;
  hideFlagsIcon?: boolean;
  className?: string;
  error?: boolean;
  errorText?: string;
}

const PhoneInput: FC<IProps> = observer(
  ({ className = '', hideFlagsIcon = false, value = '', error = false, errorText = '', ...props }: IProps): JSX.Element => {
    useEffect(() => {
      countriesStore.fetchCountries();
    }, []);

    return (
      <div dir="ltr">
        <PhoneInput2
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
          containerClass={`input input-mini  ${error ? 'input-error' : ''} ${className} ${hideFlagsIcon ? 'hide-flags' : ''}`}
          value={value}
          prefix="+"
        />
        {error && errorText ? <Text type={TEXT.ERROR} text={errorText} /> : null}
      </div>
    );
  }
);

export default PhoneInput;
